module.exports = __webpack_public_path__ + "img/logo.adb75207.svg";